import React from "react"
import styled from "react-emotion"
import Label from "./Label"
import { withTheme } from "emotion-theming"
import { Input } from ".."
import LazyLoader from "utils/LazyLoading"

class ColorPicker extends React.Component {
    state = {
        displayColorPicker: false,
        color: "#ffffff",
    }

    handleClick = () => {
        this.setState({ displayColorPicker: !this.state.displayColorPicker })
    }

    handleClose = () => {
        this.setState({ displayColorPicker: false })
    }

    handleChange = color => {
        const newColor = color && color.rgb.a === 1 ? color.hex : colorToRgb(color)
        this.setState({ color: newColor })
        this.props.onChange(newColor)
    }

    constructor(props) {
        super(props)
        if (props.color) this.state.color = props.color
    }

    componentWillReceiveProps(props) {
        if (props.color !== this.props.color) {
            this.setState({ color: props.color })
        }
        if (!props.color) {
            this.setState({ color: null })
        }
    }

    render() {
        const Color = styled("div")({
            width: "14px",
            height: "14px",
            borderRadius: "2px",
            background: this.state.color,
        })

        const Swatch = styled("div")({
            padding: "0px",
            background: "#fff",
            borderRadius: "2px",
            boxShadow: "0 0 0 1px rgba(0,0,0,.1)",
            display: "inline-block",
            cursor: "pointer",
            marginRight: "4px",
            marginBottom: "-3px",
            height: "14px",
            width: "14px",
        })

        const Popover = styled("div")({
            position: "absolute",
            top: 30,
            left: -45,
            zIndex: 1,
            fontFamily: this.props.theme.fontFamily,
            fontSize: "9px",
            transform: "translate(-0px, -7px)",
        })
        const Cover = styled("div")({
            position: "fixed",
            top: "0px",
            right: "0px",
            bottom: "0px",
            left: "0px",
        })

        const Wrapper = styled("span")`
            position: relative;
            & input {
                font-size: 9px !important;
            }

            & input.display {
                font-size 9pt !important;
            }
        `

        // this.state.displayColorPicker
        return (
            <LazyLoader getModule={() => import("react-color")}>
                {({ SketchPicker }) => (
                    <Wrapper className="color-picker interactive">
                        <Swatch onClick={this.handleClick}>
                            <Color />
                        </Swatch>
                        {this.state.displayColorPicker ? (
                            <Popover className="pop">
                                <Cover onClick={this.handleClose} />
                                <SketchPicker
                                    color={this.state.color || "#ffffff"}
                                    onChange={this.handleChange}
                                />
                            </Popover>
                        ) : null}
                        <Input
                            className="display"
                            style={{ display: "inline-block" }}
                            value={this.state.color}
                            onChange={ev => this.props.onChange(ev.target.value)}
                        />
                    </Wrapper>
                )}
            </LazyLoader>
        )
    }
}

export default withTheme(ColorPicker)

const colorToRgb = color => {
    return `rgba(${color.rgb.r}, ${color.rgb.g}, ${color.rgb.b}, ${color.rgb.a})`
}



// WEBPACK FOOTER //
// ./src/ui/components/ColorPicker.js